import React from "react";

import * as displayModes from "./displayModes";

export default function OptionsField(props) {
  const displayMode = props.cartItem?.product.displayMode;
  const Component = displayModes[displayMode];

  return Component ? <Component {...props} /> : null;
}
